// Ports of webapp/src/blocks/filterClause.ts + filterGroup.ts.

export type FilterCondition =
    'includes' | 'notIncludes' |
    'isEmpty' | 'isNotEmpty' |
    'isSet' | 'isNotSet' |
    'is' |
    'contains' | 'notContains' |
    'startsWith' | 'notStartsWith' |
    'endsWith' | 'notEndsWith' |
    'isBefore' | 'isAfter'

export type FilterClause = {
    propertyId: string
    condition: FilterCondition
    values: string[]
}

export function createFilterClause(o?: Partial<FilterClause>): FilterClause {
    return {
        propertyId: o?.propertyId || '',
        condition: o?.condition || 'includes',
        values: o?.values?.slice() || [],
    }
}

export function areFilterClausesEqual(a: FilterClause, b: FilterClause): boolean {
    return a.propertyId === b.propertyId &&
        a.condition === b.condition &&
        a.values.length === b.values.length &&
        a.values.every((v, i) => v === b.values[i])
}

export type FilterGroupOperation = 'and' | 'or'

/** A FilterGroup has 2 forms: (A or B or C) OR (A and B and C) */
export type FilterGroup = {
    operation: FilterGroupOperation
    filters: Array<FilterClause | FilterGroup>
}

export function isAFilterGroupInstance(object: FilterClause | FilterGroup): object is FilterGroup {
    return 'operation' in object && 'filters' in object
}

export function createFilterGroup(o?: Partial<FilterGroup>): FilterGroup {
    let filters: Array<FilterClause | FilterGroup> = []
    if (o?.filters) {
        filters = o.filters.map((p) => {
            if (isAFilterGroupInstance(p)) {
                return createFilterGroup(p)
            }
            return createFilterClause(p as FilterClause)
        })
    }
    return {
        operation: o?.operation || 'and',
        filters,
    }
}

export type FilterValueType = 'none' | 'options' | 'boolean' | 'text' | 'date' | 'person'
